import { render, staticRenderFns } from "./recruitInfo.vue?vue&type=template&id=68a400e1&scoped=true&"
import script from "./recruitInfo.vue?vue&type=script&lang=js&"
export * from "./recruitInfo.vue?vue&type=script&lang=js&"
import style0 from "./recruitInfo.vue?vue&type=style&index=0&id=68a400e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a400e1",
  null
  
)

export default component.exports